import { Tabs } from '@boschebike/ebds-react';
import {
  FunctionComponent,
  PropsWithChildren,
  useContext,
  useState,
} from 'react';
import { DxfIntegrationContext } from '../../context/dxfIntegrationContext';
import { useContent } from '../../hooks/use-content';
import { Header } from '../Header';
import { Container } from '../layout/Container';
import { Theme } from '../layout/Theme';
import { PageProps } from '../types';

export const Page: FunctionComponent<PropsWithChildren<PageProps>> = ({ links, enforcedTabId, children }) => {
  const content = useContent();
  const dxfIntegrationContext = useContext(DxfIntegrationContext);

  const contentKeyHeadline = content.t('portal.termsOfUse.label');
  const contentKeySubheadline = content.t('portal.headerTabs.subheadline');

  const getCurrentTab = (): string => {
    if (enforcedTabId) {
      return enforcedTabId;
    }

    return '100';
  };
  const [tabId] = useState(getCurrentTab());

  const onTabChange = (activeTabID: string): void => {
    const targetPage = links.find((element) => element.id.toString() === activeTabID)!.route;

    // Disable this for now, because it does not match the original prod behavior.
    // const id = parseInt(activeTabID, 10);
    // if (tabId === id) {
    //   return;
    // }

    dxfIntegrationContext.jumpToPage(targetPage);
  };

  return (
    <Theme>
      <Container>
        <Header
          title={contentKeyHeadline}
          headline={contentKeySubheadline}
        />

        <Tabs
          standout={false}
          activeId={tabId}
          onChange={onTabChange}
        >
          <Tabs.Navigation>
            {links.map((x) => (
              <Tabs.NavigationItem
                id={x.id}
                key={`react-key_${x.id}`}
              >
                {x.text}
              </Tabs.NavigationItem>
            ))}
          </Tabs.Navigation>
          <Tabs.Panels>
            <Tabs.PanelItem id={tabId}>
              {children /* <-- this is the actual content of the legal document */}
            </Tabs.PanelItem>
          </Tabs.Panels>
        </Tabs>
      </Container>
    </Theme>
  );
};
